import {useCallback, useMemo} from "react";
import {startOfToday} from "date-fns";

import {dateTimeFormat, formatDate, formatPL} from "@pg-mono/string-utils";

import {IRangeQuery} from "../../request/IRangeQuery";

export const useConstructionEndDate = () => {
    const today = useMemo(() => formatPL(startOfToday(), "yyyy-MM-dd"), []);

    const calculateConstructionEndDate = useCallback(
        (constructionEndDate: string | undefined | null, constructionDateRange: IRangeQuery<string> | undefined) => {
            if (constructionEndDate) {
                return constructionEndDate >= today ? formatDate(constructionEndDate, dateTimeFormat.quarter) : "Gotowe";
            }
            if (constructionDateRange) {
                return constructionDateRange.upper >= today ? formatDate(constructionDateRange.upper, dateTimeFormat.quarter) : "Gotowe";
            }
        },
        [today]
    );

    return {
        calculateConstructionEndDate
    };
};
import {useCallback, useMemo} from "react";
import {startOfToday} from "date-fns";

import {dateTimeFormat, formatDate, formatPL} from "@pg-mono/string-utils";

import {IRangeQuery} from "../../request/IRangeQuery";

export const useConstructionEndDate = () => {
    const today = useMemo(() => formatPL(startOfToday(), "yyyy-MM-dd"), []);

    const calculateConstructionEndDate = useCallback(
        (constructionEndDate: string | undefined | null, constructionDateRange: IRangeQuery<string> | undefined) => {
            if (constructionEndDate) {
                return constructionEndDate >= today ? formatDate(constructionEndDate, dateTimeFormat.quarter) : "Gotowe";
            }
            if (constructionDateRange) {
                return constructionDateRange.upper >= today ? formatDate(constructionDateRange.upper, dateTimeFormat.quarter) : "Gotowe";
            }
        },
        [today]
    );

    return {
        calculateConstructionEndDate
    };
};
